import { get, find, filter, map, isNull } from "lodash";
import { Menubar } from "primereact/menubar";
import { PageRequestError } from "components/PageRequestError";
import { ProgressSpinner } from "primereact/progressspinner";
import useApp from "hooks/useApp";
import MetricsEditPage from "pages/metrics/Edit";
import { DashboardTitle } from "components/DashboardTitle";
import { ShowMoreLess, CopyText } from "pages/modules/View";
import { useTranslation } from "react-i18next";
import useViewPage from "hooks/useViewPage";
const MetricsViewPage = (props) => {
  const app = useApp();
  const { t } = useTranslation();
  const METRIC_DETAILS = t("METRIC_DETAILS");
  const DELETE = t("DELETE");
  const { openPageDialog, navigate, metricTypes } = app;
  const pageController = useViewPage(props);
  const { item, pageReady, loading, apiRequestError, deleteItem } =
    pageController;
  function ActionButton(data) {
    const items = [
      {
        label: t("EDIT"),
        command: (event) => {
          openPageDialog(
            <MetricsEditPage
              isSubPage
              id={data.id}
              organisations={props.organisations}
              modules={props.modules}
            />,
            { closeBtn: true }
          );
        },
        icon: "pi pi-pencil",
      },
      {
        label: DELETE,
        command: (event) => {
          deleteItem(data.id, "metrics/remove_metrics");
        },
        icon: "pi pi-trash",
      },
    ];
    return <Menubar className="p-0 " model={items} />;
  }
  function PageFooter() {
    if (props.showFooter) {
      return <div className="flex justify-content-between"></div>;
    }
  }
  if (loading) {
    return (
      <div className="p-3 text-center">
        <ProgressSpinner style={{ width: "50px", height: "50px" }} />
      </div>
    );
  }
  if (apiRequestError) {
    return <PageRequestError error={apiRequestError} />;
  }
  if (pageReady) {
    const getOrgValue = (item) => {
      let orgName = "-";
      if (item && props.organisations.length > 0) {
        const org = find(
          props.organisations,
          (org) => get(org, "code") === get(item, "org_code")
        );
        orgName = org ? get(org, "name", "-") : "-";
      }
      return orgName;
    };
    const getModulesValue = (item) => {
      let moduleNames = "-";
      if (item && props.modules.length > 0) {
        const modules = filter(
          props.modules,
          (mod) =>
            find(
              get(item, "modules"),
              (moduleId) => moduleId === get(mod, "id", 0)
            ),
          []
        );
        moduleNames =
          modules.length > 0
            ? map(modules, (module) => get(module, "module_name", "")).join(
                ", "
              )
            : "-";
      }
      return moduleNames;
    };
    const getMetricTypeValue = (item) => {
      let metricTypeLabel = "-";
      if (item && metricTypes.length > 0) {
        const metricType = find(
          metricTypes,
          (mType) => get(mType, "id") === get(item, "metric_type")
        );
        metricTypeLabel = metricType ? get(metricType, "label", "-") : "-";
      }
      return metricTypeLabel;
    };
    const getNullishValue = (item, field) => {
      const val = get(item, field, "-");
      return isNull(val) ? "-" : val;
    };
    return (
      <div className="mx-auto card">
        <i
          className="pi pi-arrow-circle-left cursor-pointer"
          onClick={() => app.navigate(-1)}
          style={{ fontSize: "2rem" }}
        />
        <div className="flex justify-content-between items-center">
          <DashboardTitle
            title={`${getNullishValue(item, "name")}` + METRIC_DETAILS}
            imageSrc={item.icon}
            bgColor={`#${item.color}`}
            color="white"
          />
          {ActionButton(item)}
        </div>
        <hr />
        <div className="grid ">
          <div className="col comp-grid">
            <div>
              <div className="mb-3 grid justify-content-start">
                <div className="col-12 md:col-4">
                  <div className="flex gap-3 align-items-center p-3 ">
                    <div className="">
                      <div className="text-400 font-medium mb-1">Id</div>
                      <div className="font-bold">{get(item, "id", "-")}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-4">
                  <div className="flex gap-3 align-items-center p-3 ">
                    <div className="">
                      <div className="text-400 font-medium mb-1">
                        {t("FACILITY")}
                      </div>
                      <div className="font-bold">{getOrgValue(item)}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-4">
                  <div className="flex gap-3 align-items-center p-3 ">
                    <div className="">
                      <div className="text-400 font-medium mb-1">
                        {t("MODULES")}
                      </div>
                      <div className="font-bold">{getModulesValue(item)}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-4">
                  <div className="flex gap-3 align-items-center p-3 ">
                    <div className="">
                      <div className="text-400 font-medium mb-1">
                        {t("NAME")}
                      </div>
                      <div className="font-bold">
                        {getNullishValue(item, "name")}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-4">
                  <div className="flex gap-3 align-items-center p-3 ">
                    <div className="">
                      <div className="text-400 font-medium mb-1">
                        {t("METRIC_TYPE")}
                      </div>
                      <div className="font-bold">
                        {getMetricTypeValue(item)}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-4">
                  <div className="flex gap-3 align-items-center p-3 ">
                    <div className="">
                      <div className="text-400 font-medium mb-1">
                        {t("POSITION")}
                      </div>
                      <div className="font-bold">
                        {getNullishValue(item, "position")}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-4">
                  <div className="flex gap-3 align-items-center p-3 ">
                    <div className="">
                      <div className="text-400 font-medium mb-1">
                        {t("STATUS")}
                      </div>
                      <div className="font-bold">
                        {getNullishValue(item, "status")}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-4">
                  <div className="flex gap-3 align-items-center p-3 ">
                    <div className="">
                      <div className="text-400 font-medium mb-1">
                        {t("DETAILS")}
                      </div>
                      <div className="font-bold">
                        {getNullishValue(item, "details")}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-6">
                  <div className="flex gap-3 align-items-center p-3 ">
                    <div className="">
                      <div className="flex gap-3">
                        <div className="text-400 font-medium mb-1">
                          {t("QUERY")}
                        </div>
                        <div className="font-bold">
                          <CopyText text={getNullishValue(item, "query")} />
                        </div>
                      </div>
                      <div className="font-bold">
                        <ShowMoreLess
                          text={getNullishValue(item, "query")}
                          maxLength={150}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 md:col-6">
                  <div className="flex gap-3 align-items-center p-3 ">
                    <div className="text-container">
                      <div className="flex gap-3">
                        <div className="text-400 font-medium mb-1">
                          {t("METRIC_CONFIG")}
                        </div>
                        <div className="font-bold">
                          <CopyText
                            text={getNullishValue(item, "metric_config")}
                          />
                        </div>
                      </div>
                      <div className="font-bold">
                        <ShowMoreLess
                          text={getNullishValue(item, "metric_config")}
                          maxLength={150}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <PageFooter />
      </div>
    );
  }
};
const withDefaultProps = (Component) => {
  const WrappedComponent = (props) => {
    const { t } = useTranslation();
    const defaultProps = {
      id: null,
      primaryKey: "id",
      pageName: "metrics",
      apiPath: "metrics/get_metrics",
      routeName: "metricsview",
      msgBeforeDelete: t("ARE_YOU_SURE_TO_DELETE_METRIC"),
      msgTitle: t("DELETE_METRIC"),
      msgAfterDelete: t("METRIC_DELETED_SUCCESSFULLY"),
      showHeader: true,
      showFooter: true,
      exportButton: true,
      isSubPage: false,
    };
    return <Component {...defaultProps} {...props} />;
  };

  return WrappedComponent;
};
export default withDefaultProps(MetricsViewPage);
